import { render, staticRenderFns } from "./BaseBackground.vue?vue&type=template&id=e7e33a4a&"
import script from "./BaseBackground.vue?vue&type=script&lang=js&"
export * from "./BaseBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports